import PressReleases, { PressReleasesProps } from "./PressReleases";

export { PressReleases, PressReleasesProps };

export default PressReleases;
